import { TELEMETRY_EVENT_NAMES } from '@src/telemetry/telemetry-events.constants'
import { trackEvent } from '@src/telemetry/track'
import { getPlacingForImpactTracker } from '@src/telemetry/utils/impact.utils'

import mixpanelCl from '../../../../../telemetry/integrations/mixpanel'

const ATTENTIVE_ORIGIN = 'https://creatives.attn.tv'

const ATTENTIVE_ACTIONS = {
  EMAIL_LEAD: 'EMAIL_LEAD',
  // @i18n-ignore
  MOBILE_LEAD: 'LEAD',
} as const

const handleAttentiveFrameMessages = (event: MessageEvent) => {
  const { __attentive } = event.data || {}
  const {
    action,
    email,
    phone: mobileNumber,
    metadata: { Gender: gender } = {
      Gender: undefined,
    },
  } = __attentive || {}

  switch (action) {
    case ATTENTIVE_ACTIONS.EMAIL_LEAD:
      trackEvent(TELEMETRY_EVENT_NAMES.EMAIL_NEWSLETTER_SUBSCRIBE, {
        email,
        gender,
        placing: getPlacingForImpactTracker('popup'),
      })
      mixpanelCl.identify({ email: email, isTentativeEmail: true })
      break
    case ATTENTIVE_ACTIONS.MOBILE_LEAD:
      trackEvent(TELEMETRY_EVENT_NAMES.SMS_NEWSLETTER_SUBSCRIBE, {
        mobileNumber,
        // @i18n-ignore
        placing: 'popup',
      })
      break
  }
}

export { ATTENTIVE_ORIGIN, handleAttentiveFrameMessages }
